import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { GenericAbsService } from '../utils/generic-abs-service';
import { ApiResponse, TokenRequest, FacebookLoginRequest, RegistrationRequest, SupplierDto, UserCriteria, UserInRoleDto, UserTacDto } from '../objects';
import { moduleConfigToken, AbdaliModuleConfig } from '../app.module';

@Injectable()
export class AuthService extends GenericAbsService<ApiResponse> {

    constructor(@Inject(moduleConfigToken) private config: AbdaliModuleConfig, private http: HttpClient) {
        super(config.baseUrl, http);
    }

    login(endpoint: string = null, request: TokenRequest, headers?: HttpHeaders) {
        endpoint = endpoint == null ? '/api/v1/token' : endpoint;
        return this.post(endpoint, request, headers);
    }

    facebookLogin(endpoint: string = null, request: FacebookLoginRequest, headers?: HttpHeaders) {
        endpoint = endpoint == null ? '/api/v1/facebook' : endpoint;
        return this.post(endpoint, request, headers);
    }

    signupUser(endpoint: string = null, request: RegistrationRequest, headers?: HttpHeaders) {
        endpoint = endpoint == null ? '/api/v1/registration' : endpoint;
        return this.post(endpoint, request, headers);
    }

    addSupplier(endpoint: string = null, dto: SupplierDto, headers?: HttpHeaders) {
        endpoint = endpoint == null ? '/api/v1/supplier' : endpoint;
        return this.post(endpoint, dto, headers);
    }

    updateSupplier(endpoint: string = null, dto: SupplierDto, headers?: HttpHeaders) {
        endpoint = endpoint == null ? '/api/v1/supplier' : endpoint;
        return this.put(endpoint, dto, headers);
    }

    getSupplierById(endpoint: string = null, suppId: number, headers?: HttpHeaders) {
        endpoint = endpoint == null ? '/api/v1/supplier' : endpoint;
        return this.getById(endpoint, suppId, headers);
    }

    supplierList(endpoint: string = null, headers?: HttpHeaders) {
        endpoint = endpoint == null ? '/api/v1/supplier' : endpoint;
        return this.getAll(endpoint, headers);
    }

    supplierStatusList(endpoint: string = null, headers?: HttpHeaders) {
        endpoint = endpoint == null ? '/api/v1/supplier/status' : endpoint;
        return this.getAll(endpoint, headers);
    }

    userListing(criteria: UserCriteria, headers?: HttpHeaders) {
        const endpoint = `/api/v1/user?pageIndex=${criteria.pageIndex ? criteria.pageIndex : ''}&pageSize=${criteria.pageSize ? criteria.pageSize : ''}`;
        return this.getAll(endpoint);
    }

    roleListing(endpoint: string = null, headers?: HttpHeaders) {
        endpoint = endpoint == null ? '/api/v1/user/roles' : endpoint;
        return this.getAll(endpoint, headers);
    }

    assignRoleToUser(endpoint: string = null, list: Array<UserInRoleDto>, headers?: HttpHeaders) {
        endpoint = endpoint == null ? '/api/v1/user/assign-roles' : endpoint;
        return this.http.post<ApiResponse>(this.config.baseUrl + endpoint, list, { headers: headers });
    }

    getUserById(endpoint: string = null, userId: number, headers?: HttpHeaders) {
        endpoint = endpoint == null ? '/api/v1/user/assign-roles' : endpoint;
        return this.getById(endpoint, userId, headers);
    }

    getDrivers(endpoint: string = null, headers?: HttpHeaders) {
        endpoint = endpoint == null ? '/api/v1/user/driver' : endpoint;
        return this.getAll(endpoint, headers);
    }

    assignUserToSupplier(userId: number, supplierId: number, headers?: HttpHeaders) {
        const endpoint = `/api/v1/supplier/${supplierId}/assign-user/${userId}`;
        return this.getAll(endpoint, headers);
    }

    deleteUserFromSupplier(userId: number, supplierId: number, headers?: HttpHeaders) {
        const endpoint = `/api/v1/supplier/${supplierId}/delete-user/${userId}`
        return this.delete(endpoint, null, headers);
    }

    updateStatusToVerified(endpoint: string = null, dto: UserTacDto, headers?: HttpHeaders) {
        endpoint = endpoint == null ? '/api/v1/login/status' : endpoint;
        return this.post(endpoint, dto, headers);
    }

    generateTacCode(username: string, headers?: HttpHeaders) {
        const endpoint = '/api/v1/login/tac/' + username;
        return this.getAll(endpoint, headers);
    }

    updateUserPassword(endpoint: string = null, dto: UserTacDto, headers?: HttpHeaders) {
        endpoint = endpoint == null ? '/api/v1/login/update-pwd' : endpoint;
        return this.post(endpoint, dto, headers);
    }

    getFacebookUser(fbAccessToken: string, userId: string, headers?: HttpHeaders) {
        const endpoint = `/api/v1/facebook/user/${userId}?fb_access_token=${fbAccessToken}`;
        return this.getAll(endpoint, headers);
    }
}
